import { GET_ROUTE_CATEGORIES } from '../types';

const initialState = {
  routeCategories: []
};

export default function RouteCategoryReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ROUTE_CATEGORIES:
      return {
        ...state,
        routeCategories: action.payload
      };
    default:
      return state;
  }
}
